import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';

export const LoginPageContainer = styled('div')({
  display: 'inline-block',
  width: '100vw',
  height: '100vh',
  background: '#FAFAFA'
});

export const CenterBox = styled(Box)({
  height: '350px',
  width: '500px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '30vh',
  borderRadius: '24px',
  background: 'white',
  border: '1px solid #D4D7DC'
});

export const TitleTypography = styled(Typography)<TypographyProps>({
  fontFamily: 'Jost',
  color: '#512EBB',
  fontSize: '49px',
  fontWeight: '600',
  marginTop: '50px',
  textAlign: 'center',
  letterSpacing: '0.15px'
});

export const WelcomeTypography = styled(Typography)<TypographyProps>({
  fontFamily: 'Jost',
  fontSize: '24px',
  color: 'black',
  textAlign: 'center'
});

export const Spinner = styled(CircularProgress)({
  color: '#5F65F6',
  marginTop: '50vh',
  marginLeft: '50%'
});

export const LoginButtonContainer = styled('div')({
  marginTop: '80px',
  textAlign: 'center'
});

export const LoginButton = styled(Button)({
  fontFamily: 'Open sans',
  textTransform: 'none',
  backgroundColor: '#5F65F6',
  width: '169px',
  height: '42px',
  color: 'white',
  '&:hover': {
    backgroundColor: '#5F65F6'
  }
});

export const LogoutButton = styled(Button)({
  fontFamily: 'Open sans',
  textTransform: 'none',
  backgroundColor: '#FFFFFF',
  width: '129px',
  height: '48px',
  color: '#212121',
  '&:hover': {
    backgroundColor: '#FFFFFF'
  }
});
